import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement("g", { clipPath: "url(#calendar-warning_svg__clip0_2651_15045)" }, /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M9.235 16.999h-7.07a.5.5 0 01-.5-.5v-8.5a.5.5 0 01.5-.5h13.5a.5.5 0 01.5.5v2.07a7.177 7.177 0 012 0V3.5a1 1 0 00-1-1h-2.5a.25.25 0 01-.25-.25v-1a.75.75 0 10-1.5 0V5a.75.75 0 01-1.5 0V3a.5.5 0 00-.5-.5h-4.25a.25.25 0 01-.25-.25v-1a.75.75 0 10-1.5 0V5a.75.75 0 11-1.5 0V3a.5.5 0 00-.5-.5H.667a1 1 0 00-1 1V17a2 2 0 002 2h7.57a7.18 7.18 0 010-2z",
      fill: "#333"
    }
  ), /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M17.066 11.3a6.731 6.731 0 00-4.691 2.008 6.517 6.517 0 00-1.909 4.708 6.48 6.48 0 006.49 6.484h.11a6.66 6.66 0 006.6-6.715 6.474 6.474 0 00-6.6-6.484zm-.825 9.097a.815.815 0 01.825-.847.842.842 0 01.784 1.128.81.81 0 01-.757.522.842.842 0 01-.852-.803zm.275-2.2v-3.3a.55.55 0 011.1 0v3.3a.55.55 0 01-1.1 0z",
      fill: "#DBA100"
    }
  )),
  /* @__PURE__ */ a.createElement("defs", null, /* @__PURE__ */ a.createElement("clipPath", { id: "calendar-warning_svg__clip0_2651_15045" }, /* @__PURE__ */ a.createElement("path", { fill: "#fff", transform: "translate(0 .5)", d: "M0 0h24v24H0z" })))
);
export {
  t as default
};
